import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import ImageR from '../assets/img/Icons/Icons/image.png'

import ImageQ from '../assets/img/Icons/Icons/imageQ.png'
import ImageC from '../assets/img/Icons/Icons/imagechat.png'
import Barside from '../assets/img/Icons/Icons/Icon-17.png'

import Imgcard1 from '../assets/img/Icons/Icons/cameraI.jpg'
import RedL from '../assets/img/Icons/Icons/sm-barcode.png'

import Barcodes from '../assets/img/Icons/Icons/checkoutbarcode.png'
import Footer from '../pages/footer'
const List = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17">
                    <div className="row mt-3">
                    <div className="col-sm-1-my17-C ">
                        <Sidebar/>
                            {/* <p className="mb-0"><img src={Barside} className="Barside" alt="" /></p> */}
                        </div>
                      
                        <div className="col-sm-9-my17 text-center ">

                            <h5 className=" signin1-h1-top ml-5 mb-0">List</h5>
                        </div>

                        <div className="col-sm-3-my17 text-center ">
                            <a href="" className="text-dark fw500 ">Clear List</a>
                        </div>

                    </div>

                    <div className="row page17-p">
                        <div className="col-sm-12 py-2">
                            <hr className="mt-2" />

                            <div className=" row px-3">
                                <div className="col-sm-11-LSB">
                                    <div className="input-group mb-3 shadow">
                                        <input type="text" className="form-control border-right-0" placeholder="&#xF002; Search" style={{ height: "47px", fontFamily: "Arial, FontAwesome" }} aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                        <div className=" input-group-append border-left-0">
                                            <span className="input-group-text bg-white p-1 border-left-0" id="basic-addon2"><button type="button" className="btn btn-success">Add</button></span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-1-LSB">
                                    <img src={RedL} alt="" className="RedL" />
                                </div>
                            </div>



                            <div>
                                <ul className="nav nav-tab mt-2 mb-2" role="tablist">
                                    <li className="nav-item w-50">
                                        <a className="nav-link active text-center" data-toggle="tab" href="#tabs-1" role="tab"><small>Shopping List</small></a>
                                    </li>
                                    <li className="nav-item w-50">
                                        <a className="nav-link text-center" data-toggle="tab" href="#tabs-2" role="tab"><small>Check Out</small></a>
                                    </li>
                                </ul>


                                <div className="tab-content">
                                    <div className="tab-pane active" id="tabs-1" role="tabpanel">
                                        <div className="row  scroll-inner2">
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2 mb-1 ">
                                                <div className="px-3 card-hori-t">
                                                    <div className="row ">
                                                        <div className="col-sm-3-my px-0">
                                                            <div className="List-card-img-outer-left">
                                                                <img src={Imgcard1} alt="" className="card-img-left" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-9-my bg-light List-card-img-right">
                                                            <div className="p-3">
                                                                <p className=" List-card-img-right-p1">Deal of the week free Coffee</p>
                                                                <p className="mb-0 List-card-img-right-p2 text-secondary-light-gray">Lorem ipsum dolor sit amet </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className="tab-pane" id="tabs-2" role="tabpanel">
                                        <div className="row px-4 " style={{ marginTop: "25%" }}>
                                            <div className="col-sm-12 text-center">
                                                <h3 className="text-red my-3">MEMBER #:5887456</h3>
                                                <div className="mt-5">
                                                    <img src={Barcodes} className="List-checkout-barcode" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default List;

